import { ElMessage, ElMessageBox } from "element-plus";
import { reactive, ref } from "vue";
import { queryApprovalTable, queryApprovalCount } from "@/api/approval";
import { postDownload } from "@/utils";

export default function useApprovalTable() {
  // 搜索条件ref
  const searchRef = ref(null);

  // 搜索条件表单
  const searchData = reactive({
    category: null,
    processStatus: null,
  });

  // 数据状态与菜单的映射
  const statusToMenu = reactive({
    pending: 1,
    processed: 2,
    myself: 3,
  });

  // 表格列配置
  const columns = ref([
    {
      label: "类型",
      prop: "category",
    },
    {
      label: "执行人",
      prop: "dutyUserName",
    },
    {
      label: "创建人",
      prop: "createByName",
    },
    {
      label: "创建时间",
      prop: "createTime",
    },
    {
      label: "修改时间",
      prop: "updateTime",
    },
    {
      label: "状态",
      prop: "processStatus",
    },
  ]);

  // 表格遮罩
  const tableLoading = ref(false);

  // 表格数据
  const tableData = ref([]);

  // 默认选中的筛选条件
  const activeIndex = ref("pending");

  // 审核弹窗ref
  const approvalRef = ref(null);

  // 详情弹窗ref
  const approvalDetailRef = ref(null);

  // 表格删选类对象
  const menuList = ref([
    {
      index: "pending",
      label: "待处理",
    },
    {
      index: "processed",
      label: "已处理",
    },
    {
      index: "myself",
      label: "我发起的",
    },
  ]);

  // 待办已办发起数量对象
  const countObj = ref({
    completedQuantity: 0,
    initiateQuantity: 0,
    pendingQuantity: 0,
  });

  // 待办已办发起数量和菜单的映射
  const countToMenu = reactive({
    pending: "pendingQuantity",
    processed: "completedQuantity",
    myself: "initiateQuantity",
  });

  // 分页数据
  const pages = reactive({
    page: 1,
    limit: 10,
    total: 0,
  });

  // 获取数据
  const getList = () => {
    tableLoading.value = true;
    queryApprovalTable({
      ...searchData,
      page: pages.page,
      approvalStatus: statusToMenu[activeIndex.value],
    })
      .then((res) => {
        tableData.value = res.data.records;
        pages.total = res.data.total;
      })
      .finally(() => {
        tableLoading.value = false;
        getApprovalCount();
      });
  };

  // 点击重置
  const handleReset = () => {
    searchRef.value?.resetFields();
    getList();
  };

  // 点击导出
  const handleExport = () => {
    ElMessageBox.confirm("确定导出审核数据吗？", "导出", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
    })
      .then(() => {})
      .catch(() => {});
  };

  // 提交审核
  const handleSubmitApproval = (row) => {
    approvalRef.value?.handleDialogOpen(row);
  };

  // 点击待办已办发起按钮
  const handleMenuSelect = (val) => {
    activeIndex.value = val;
    getList();
  };

  // 获取待办已办发起数量
  const getApprovalCount = () => {
    queryApprovalCount({}).then((res) => {
      countObj.value = { ...res.data };
    });
  };

  // 点击详情
  const handleDetail = (row) => {
    approvalDetailRef.value?.handleDialogOpen(row);
  };
  return {
    searchRef,
    searchData,
    columns,
    tableLoading,
    tableData,
    menuList,
    activeIndex,
    pages,
    approvalRef,
    countObj,
    countToMenu,
    approvalDetailRef,
    getList,
    handleReset,
    handleExport,
    handleMenuSelect,
    handleSubmitApproval,
    handleDetail,
  };
}
